import { isEmpty } from 'lodash-es';
import { h } from './index-34617187.js';

function renderSuccessMessage(isValid, isSuccess, successMessage, className) {
    if (isValid && isSuccess && !isEmpty(successMessage)) {
        return h("span", { class: className }, successMessage);
    }
}

export { renderSuccessMessage as r };
